import { defineCustomElement } from '@tyler-components-web/core';
import { DateRangePickerComponent } from './date-range-picker';
export * from './date-range-picker';
export * from './date-range-picker-adapter';
export * from './date-range-picker-constants';
export * from './date-range-picker-foundation';
export * from './date-range-picker-component-delegate';
export function defineDateRangePickerComponent() {
    defineCustomElement(DateRangePickerComponent);
}
